import React, { Fragment, useState } from "react";
import styles from "./MobileMenu.module.scss";
import classnames from "classnames";
import injectSectionElements from "../injectSectionElements";
import CloseIcon from "./CloseIcon";
import BurgerIcon from "./BurgerIcon";
const MobileMenu = props => {
  const [isOpen, setOpen] = useState(false);
  const {
    Elements,
    toggleClass,
    burgerClass,
    className,
    pages,
    languages,
    displayClass,
    menuItems,
    email,
    phone,
    emailIcon,
    phoneIcon,
    socialLinks,
    primaryButton,
    secondaryButton
  } = props;
  const isLinksExist = email || phone || socialLinks || primaryButton || secondaryButton;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.burger, toggleClass, displayClass),
    onClick: () => {
      setOpen(true);
    }
  }, /*#__PURE__*/React.createElement(BurgerIcon, {
    className: classnames(burgerClass)
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(displayClass, styles.menuContainer, {
      [className]: !!className,
      [styles.defaultMenuStyle]: !className,
      [styles["--open"]]: isOpen
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.closeButton,
    onClick: () => {
      setOpen(false);
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.menuLinksContainer)
  }, /*#__PURE__*/React.createElement(Elements.NavMenu, {
    isMobile: true,
    className: styles.navMenu,
    itemClass: styles.navItem,
    linkClass: styles.navLink,
    itemActive: styles.navItemActive,
    pages: pages,
    menuItems: menuItems
  })), isLinksExist && /*#__PURE__*/React.createElement("div", {
    className: styles.linksWrapper
  }, email && /*#__PURE__*/React.createElement("div", {
    className: styles.styledFlex
  }, /*#__PURE__*/React.createElement(Elements.Icon, {
    value: emailIcon,
    className: styles.icon
  }), /*#__PURE__*/React.createElement(Elements.Button, {
    type: "Link",
    value: email,
    className: styles.linkButton
  })), phone && /*#__PURE__*/React.createElement("div", {
    className: styles.styledFlex
  }, /*#__PURE__*/React.createElement(Elements.Icon, {
    value: phoneIcon,
    className: styles.icon
  }), /*#__PURE__*/React.createElement(Elements.Button, {
    type: "Link",
    value: phone,
    className: styles.linkButton
  })), socialLinks && /*#__PURE__*/React.createElement("div", {
    className: styles.styledFlex
  }, /*#__PURE__*/React.createElement(Elements.SocialLinks, {
    value: socialLinks
  })), /*#__PURE__*/React.createElement("div", null, primaryButton && /*#__PURE__*/React.createElement("div", {
    className: styles.styledButton
  }, /*#__PURE__*/React.createElement(Elements.Button, {
    type: "Primary",
    value: primaryButton
  })), secondaryButton && /*#__PURE__*/React.createElement("div", {
    className: styles.styledButton
  }, /*#__PURE__*/React.createElement(Elements.Button, {
    type: "Secondary",
    value: secondaryButton
  })))), languages.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: styles.fixedBottom
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement(Elements.LanguageSwitcher, {
    dropTo: "top",
    labelClass: styles.languageSwitcher,
    languages: languages
  }))));
};
export default injectSectionElements(MobileMenu);
//# sourceMappingURL=MobileMenu.js.map